import AssignList from "Containers/ClientTracking/AssignList";
import ParamsList from "Containers/ClientTracking/ParamsList";
import MyClientsList from "Containers/ClientTracking/MyClientsList";
import ChecklistList from "Containers/ClientTracking/ChecklistList";

const Actions = {
  client_tracking_assign: {
    view: {
      codenames: [],
      action_code: "visible_client_tracking_assign_view",
      is_superuser_action: false,
      name: "View Supervisor Configuration",
      label: "Supervisor Configuration",
      action: "sub-menu",
      url: "/client-tracking/assign",
      component: <AssignList />,
      permission_needed: true,
    },
    name: "Supervisor Configuration",
    type: "Client Tracking",
  },
  client_tracking_params: {
    view: {
      codenames: [],
      action_code: "visible_client_tracking_params_view",
      is_superuser_action: false,
      name: "View Modules",
      label: "Modules",
      action: "sub-menu",
      url: "/client-tracking/params",
      component: <ParamsList />,
      permission_needed: true,
    },
    name: "Modules",
    type: "Client Tracking",
  },
  client_tracking_my_clients: {
    view: {
      codenames: [],
      action_code: "visible_client_tracking_my_clients_view",
      is_superuser_action: false,
      name: "View My Clients",
      label: "My Clients",
      action: "sub-menu",
      url: "/client-tracking/my-clients",
      component: <MyClientsList />,
      permission_needed: true,
    },
    name: "My Clients",
    type: "Client Tracking",
  },
  client_tracking_checklist: {
    view: {
      codenames: [],
      action_code: "visible_client_tracking_checklist_view",
      is_superuser_action: false,
      name: "View Checklist",
      label: "Checklist",
      action: "sub-menu",
      url: "/client-tracking/checklist",
      component: <ChecklistList />,
      permission_needed: true,
    },
    name: "Checklist",
    type: "Client Tracking",
  },
};

export default Actions;
